/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Profile_UpdatedInputs */

const en_common_profile_updated = /** @type {(inputs: Common_Profile_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully updated profile`)
};

const es_common_profile_updated = /** @type {(inputs: Common_Profile_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil actualizado correctamente`)
};

/**
* | output |
* | --- |
* | "Successfully updated profile" |
*
* @param {Common_Profile_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_profile_updated = /** @type {((inputs?: Common_Profile_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Profile_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_profile_updated(inputs)
	return en_common_profile_updated(inputs)
});